var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"w100"},[_c('el-carousel',{attrs:{"interval":_vm.interval,"type":_vm.type,"autoplay":_vm.autoplay,"direction":_vm.direction,"arrow":_vm.arrow,"trigger":_vm.trigger,"indicator-position":_vm.position}},_vm._l((_vm.datas),function(data,i){return _c('el-carousel-item',{key:i},[_c('el-image',{attrs:{"src":data.filePath}})],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89139da2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/showMoudle/eleImages.vue
// module id = 45
// module chunks = 0